import { FileText } from 'lucide-react';

export default function TermsContent() {
  return (
    <div className="prose prose-sm prose-invert max-w-none">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-800">
        <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <FileText className="text-white" size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white m-0">Terms of Service</h1>
          <p className="text-sm text-gray-400 mt-0.5 m-0">เงื่อนไขการให้บริการ</p>
        </div>
      </div>

      {/* Content */}
      <div className="space-y-6 text-sm">
        {/* Section 1 */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">1. การยอมรับเงื่อนไข</h2>
          <p className="text-gray-300 leading-relaxed">
            เมื่อท่านเข้าใช้บริการของ HitzLink ถือว่าท่านได้อ่าน เข้าใจ และยอมรับเงื่อนไขการให้บริการทั้งหมดนี้ 
            หากท่านไม่เห็นด้วยกับเงื่อนไขใดๆ กรุณาหยุดการใช้บริการทันที
          </p>
        </section>

        {/* Section 2 */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">2. การใช้บริการ</h2>
          <div className="space-y-3">
            <div>
              <p className="text-white font-medium mb-2">2.1 การสมัครสมาชิก</p>
              <ul className="list-disc list-inside ml-3 space-y-1 text-gray-300">
                <li>ท่านต้องมีอายุไม่ต่ำกว่า 18 ปีบริบูรณ์</li>
                <li>ข้อมูลที่ให้ต้องถูกต้อง ครบถ้วน และเป็นปัจจุบัน</li>
                <li>ท่านรับผิดชอบในการรักษาความปลอดภัยของบัญชีของท่าน</li>
                <li>ห้ามแชร์บัญชีหรือรหัสผ่านกับบุคคลอื่น</li>
              </ul>
            </div>

            <div>
              <p className="text-white font-medium mb-2">2.2 การใช้งานที่อนุญาต</p>
              <ul className="list-disc list-inside ml-3 space-y-1 text-gray-300">
                <li>ใช้เพื่อสร้าง Landing Pages ที่ถูกกฎหมาย</li>
                <li>ไม่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น</li>
                <li>ไม่เผยแพร่เนื้อหาที่ผิดกฎหมาย หลอกลวง หรือไม่เหมาะสม</li>
                <li>ไม่ใช้บริการเพื่อกระทำการใดๆ ที่เป็นอันตรายต่อระบบ</li>
              </ul>
            </div>

            <div>
              <p className="text-white font-medium mb-2">2.3 การใช้งานที่ห้าม</p>
              <ul className="list-disc list-inside ml-3 space-y-1 text-gray-300">
                <li>❌ เนื้อหาที่ผิดกฎหมาย การพนัน หวย หรือสิ่งเสพติด</li>
                <li>❌ เนื้อหาลามก อนาจาร หรือไม่เหมาะสมกับเยาวชน</li>
                <li>❌ Phishing, Scam หรือการหลอกลวงในรูปแบบใดๆ</li>
                <li>❌ Spam หรือการส่งข้อความรบกวนจำนวนมาก</li>
                <li>❌ Malware, Virus หรือโค้ดที่เป็นอันตราย</li>
                <li>❌ การโจมตี DDoS หรือพยายามเจาะระบบ</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 3 */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">3. แผนบริการและราคา</h2>
          <div className="grid sm:grid-cols-3 gap-3">
            <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-3">
              <p className="text-white font-semibold mb-2">Free</p>
              <ul className="text-xs text-gray-300 space-y-1">
                <li>• 1 Landing Page</li>
                <li>• Basic Analytics</li>
                <li>• 1 FB Pixel</li>
                <li>• ฟรีตลอดชีพ</li>
              </ul>
            </div>
            <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-3">
              <p className="text-white font-semibold mb-2">Plus (499฿/เดือน)</p>
              <ul className="text-xs text-gray-300 space-y-1">
                <li>• 5 Landing Pages</li>
                <li>• Advanced Analytics</li>
                <li>• 1 FB Pixel</li>
                <li>• Device Redirect</li>
                <li>• Custom Domain</li>
              </ul>
            </div>
            <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-3">
              <p className="text-white font-semibold mb-2">Pro (899฿/เดือน)</p>
              <ul className="text-xs text-gray-300 space-y-1">
                <li>• Unlimited Pages</li>
                <li>• Advanced Analytics</li>
                <li>• Multiple FB Pixels</li>
                <li>• Bot Cloaking</li>
                <li>• Device Redirect</li>
                <li>• Custom Domain</li>
                <li>• Remove Branding</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 4 - Payment */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">4. การชำระเงินและการเติมเงิน</h2>
          <div className="space-y-3">
            <div className="bg-green-900/20 border border-green-700/50 rounded p-3">
              <p className="text-green-300 text-xs font-medium mb-2">✅ ระบบชำระเงินอัตโนมัติ</p>
              <ul className="text-xs text-gray-300 space-y-1">
                <li>• ตรวจสอบการชำระเงินอัตโนมัติภายใน 1-5 นาที</li>
                <li>• ไม่ต้องส่งสลิปการโอนเงิน</li>
                <li>• แจ้งเตือนทาง Email อัตโนมัติ</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 5 - Refund */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">5. นโยบายการคืนเงิน</h2>
          <div className="bg-orange-900/20 border border-orange-700/50 rounded p-3 mb-3">
            <p className="text-orange-300 text-xs font-medium">
              ⚠️ คืนเงินภายใน 24 ชั่วโมง (เงื่อนไข: ยังไม่ได้สร้าง Landing Page)
            </p>
          </div>
          <div className="grid sm:grid-cols-2 gap-3 text-xs">
            <div>
              <p className="text-green-400 font-medium mb-2">✅ คืนเงินได้</p>
              <ul className="text-gray-300 space-y-1">
                <li>• ระบบไม่เปิดแผนภายใน 24 ชม.</li>
                <li>• ชำระซ้ำโดยไม่ตั้งใจ</li>
                <li>• ระบบ Down (ภายใน 24 ชม.)</li>
              </ul>
            </div>
            <div>
              <p className="text-red-400 font-medium mb-2">❌ ไม่คืนเงิน</p>
              <ul className="text-gray-300 space-y-1">
                <li>• เกิน 24 ชั่วโมงแล้ว</li>
                <li>• สร้าง Page แล้ว (แม้แค่ 1 หน้า)</li>
                <li>• เปลี่ยนใจ / ไม่ต้องการใช้</li>
                <li>• ละเมิดเงื่อนไข</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Additional Sections - Condensed */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">6. การยกเลิกและดาวน์เกรดแผน</h2>
          <p className="text-gray-300 text-xs">
            ท่านสามารถยกเลิกแผนได้ทุกเมื่อโดยไม่มีค่าปรับ แผนจะใช้งานได้จนถึงสิ้นรอบบิล 
            หลังจากนั้นจะดาวน์เกรดเป็นแผน Free อัตโนมัติ
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white mb-3">7. ข้อจำกัดความรับผิดชอบ</h2>
          <p className="text-gray-300 text-xs">
            เราพยายามให้บริการพร้อมใช้งาน 99.9% ของเวลา แต่ไม่รับประกันการให้บริการแบบไม่มีสะดุดเลย 
            เราไม่รับผิดชอบต่อความเสียหายทางอ้อม เช่น การสูญเสียรายได้ ชื่อเสียง หรือโอกาสทางธุรกิจ
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white mb-3">8. การระงับและยกเลิกบัญชี</h2>
          <p className="text-gray-300 text-xs">
            เราสงวนสิทธิ์ในการระงับหรือยกเลิกบัญชีหากพบการละเมิดเงื่อนไข การใช้งานผิดกฎหมาย 
            หรือสร้างความเสียหายต่อระบบ ท่านสามารถขอลบบัญชีได้ทุกเมื่อ แต่ข้อมูลจะถูกลบอย่างถาวร
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white mb-3">9. การเปลี่ยนแปลงเงื่อนไข</h2>
          <p className="text-gray-300 text-xs">
            เราสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขได้ทุกเมื่อ โดยจะแจ้งให้ท่านทราบล่วงหน้าอย่างน้อย 30 วัน
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white mb-3">10. กฎหมายที่ใช้บังคับ</h2>
          <p className="text-gray-300 text-xs">
            เงื่อนไขการให้บริการนี้อยู่ภายใต้กฎหมายของประเทศไทย ข้อพิพาทใดๆ ให้อยู่ในเขตอำนาจศาลไทย
          </p>
        </section>

        {/* Section 11 — Third-party integrations.
            Required disclosures for Google OAuth verification AND
            Meta CAPI partner-program review. Spells out clearly that
            HitzLink is not affiliated with Google/Meta and that the
            user remains responsible for complying with each platform's
            own ToS. */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">
            11. การเชื่อมต่อกับบริการของบุคคลที่สาม (Google, Meta)
          </h2>

          <div className="space-y-3 text-xs text-gray-300">
            <div>
              <p className="text-white font-medium mb-1.5">11.1 Independent Service</p>
              <p className="leading-relaxed">
                HitzLink เป็นบริการของ <strong className="text-white">บริษัท ฮิตซ์เทค โซลูชั่นส์ จำกัด</strong>{' '}
                (Hitz Tech Solutions Co., Ltd.) ซึ่งเป็นนิติบุคคลที่จดทะเบียนในประเทศไทย
                และเป็นอิสระ <strong className="text-white">ไม่มีความเกี่ยวข้อง</strong> ไม่ได้เป็นพันธมิตรทางการ
                และไม่ได้รับการรับรองจาก Google LLC, Meta Platforms, Inc.
                หรือบริษัทในเครือใดๆ การใช้ชื่อหรือเครื่องหมายการค้าของบริษัทเหล่านั้น
                ในเว็บไซต์ของเรามีไว้เพื่อระบุความเข้ากันได้ทางเทคนิค (interoperability)
                เท่านั้น
              </p>
            </div>

            <div>
              <p className="text-white font-medium mb-1.5">11.2 ความรับผิดชอบของท่าน</p>
              <p className="leading-relaxed mb-1.5">
                เมื่อท่านเชื่อมต่อบัญชี Google หรือ Meta กับ HitzLink ท่านยังคงต้อง
                ปฏิบัติตามเงื่อนไขของผู้ให้บริการเหล่านั้นทั้งหมด รวมถึงแต่ไม่จำกัดเฉพาะ:
              </p>
              <ul className="list-disc list-inside ml-3 space-y-1">
                <li>
                  <a
                    href="https://marketingplatform.google.com/about/analytics/tag-manager/use-policy/"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="text-blue-300 hover:text-blue-200 underline"
                  >
                    Google Tag Manager Use Policy
                  </a>
                </li>
                <li>
                  <a
                    href="https://policies.google.com/terms"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="text-blue-300 hover:text-blue-200 underline"
                  >
                    Google Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/legal/terms/businesstools"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="text-blue-300 hover:text-blue-200 underline"
                  >
                    Meta Business Tools Terms
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/legal/terms/customaudience"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="text-blue-300 hover:text-blue-200 underline"
                  >
                    Meta Custom Audiences Terms
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <p className="text-white font-medium mb-1.5">11.3 ขอบเขตการเข้าถึง (Scope)</p>
              <p className="leading-relaxed">
                เราขอ OAuth scope ขั้นต่ำที่จำเป็นสำหรับฟีเจอร์เท่านั้น
                (สำหรับ Google Tag Manager คือ <code className="px-1.5 py-0.5 rounded bg-gray-800 text-blue-200">tagmanager.edit.containers</code>{' '}
                — แก้ไข tags / triggers / variables ใน container ของท่านเท่านั้น
                ไม่มีสิทธิ์ publish, ไม่มีสิทธิ์อ่าน Google services อื่น)
                รายละเอียดทั้งหมดอยู่ใน{' '}
                <a href="/privacy" className="text-blue-300 hover:text-blue-200 underline">
                  Privacy Policy หัวข้อ 8
                </a>
              </p>
            </div>

            <div>
              <p className="text-white font-medium mb-1.5">11.4 การเพิกถอนสิทธิ์</p>
              <p className="leading-relaxed">
                ท่านสามารถ <strong className="text-white">disconnect</strong>{' '}
                การเชื่อมต่อ Google ได้ตลอดเวลาในหน้า Meta CAPI ของแอป (จะ revoke
                token ที่ Google โดยอัตโนมัติ) หรือเข้าไปเพิกถอนตรงๆ ที่{' '}
                <a
                  href="https://myaccount.google.com/permissions"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-blue-300 hover:text-blue-200 underline"
                >
                  myaccount.google.com/permissions
                </a>
                . การ disconnect จะหยุดการ sync อัตโนมัติทันที
                แต่ <strong>จะไม่ลบ tags ที่เคยสร้างไว้ใน GTM ของท่าน</strong> —
                ท่านสามารถลบ workspace "HitzLink Managed" ได้เองหากต้องการ
              </p>
            </div>

            <div>
              <p className="text-white font-medium mb-1.5">11.5 ข้อจำกัดความรับผิดชอบ</p>
              <p className="leading-relaxed">
                Google และ Meta อาจเปลี่ยนแปลง API, scope, rate limit หรือ
                เพิกถอนสิทธิ์การเข้าถึงของแอปบุคคลที่สามได้ตลอดเวลา HitzLink
                ไม่รับผิดชอบต่อความเสียหายที่เกิดจากการเปลี่ยนแปลงเหล่านั้น
                แต่จะพยายามแจ้งเตือนล่วงหน้าผ่านอีเมล / in-app notification
                เมื่อทราบล่วงหน้า
              </p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <div className="mt-6 pt-4 border-t border-gray-800">
          <div className="bg-blue-900/20 border border-blue-700/50 rounded p-4">
            <p className="text-white font-semibold text-sm mb-2">📧 ติดต่อเรา</p>
            <div className="text-xs text-gray-300 space-y-1">
              <p><strong>นิติบุคคล:</strong> บริษัท ฮิตซ์เทค โซลูชั่นส์ จำกัด (Hitz Tech Solutions Co., Ltd.)</p>
              <p><strong>Email:</strong> support@hitzlink.com</p>
              <p><strong>Website:</strong> https://hitzlink.com</p>
              <p><strong>Hours:</strong> Mon-Fri, 9:00-18:00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

